import { useQuery } from '@tanstack/react-query';
import { getAuditorAverageRate } from '../api/getAuditorAverageRate';

// TODO: Refactor this - maybe an endpoint to check reminders status or add it in token
export const useAverageRate = (isAuditor: boolean) => {
  const query = useQuery({
    enabled: isAuditor,
    queryKey: ['get-user-avarage-rate'],
    queryFn: () => getAuditorAverageRate(),
  });

  if (query.isLoading) return { grade: 0 };

  if (query.error) return { grade: 0 };

  if (!query.data) return { grade: 0 };

  return query.data;
};
